import { Component, ElementRef, Injector, Input, OnInit } from '@angular/core';
import { WidgetBaseComponent } from '../../widgetBase';

/**
 * LeaseExpiry Widget
 */
@Component({
  selector: 'lease-expiry-widget',
  templateUrl: './lease-expiry-widget.component.html',
  styleUrls: ['./lease-expiry-widget.component.scss']
})
export class LeaseExpiryWidgetComponent extends WidgetBaseComponent implements OnInit {

  /**
   * Widget Guid
   */
  @Input() widgetGuid: string;

  /**
   * Table Container Height
   */
  public tableContainerHeight = '';

  /**
  * Constructor
  * @param el ElementRef
  */
  constructor(private el: ElementRef, injector: Injector) {
    super(injector, 'leaseExpiry', false);
  }

  /**
   * Initializes the component
   */
  ngOnInit() {
    // will call registerEvents and onInitialized when config (this.widgetConfig and this.page) is ready
    this.initWidgetConfig();
    this.widgetResized();
  }

  /**
   * Called by base class to let widget register to various app events (like saving, loading, resizing etc)
   */
  registerEvents(): void {
    this.useReadOnlySaveChangesHandler();
  }

  /**
   * Called by base class to inform widget that it is initialized
   * Mostly used to define where widget data should be loaded from
   */
  onInitialized(): void {
    this.mockupData$ = this.widgetService.loadEmpty();

    this.widgetData$ = this.mockup ?
      this.widgetService.loadMockupData('assets/data/polluxMock.widget-leaseExpiry.json').pipe()
      : this.widgetService.load('leaseExpiry', this.getReport()).pipe();
  }

  /**
   * widgetResized event handler
   */
  widgetResized() {
    //get height of gridster, so we can adjust chart table container height
    const gridsterEl = this.getGridsterElement(this.el);
    const height = parseInt(gridsterEl.style.height);
    this.tableContainerHeight = `${height}px`;
  }

  /**
   * Returns label content
  * @param e {any} Event object
   */
  labelContent(e: any): string {
    return `${e.category}\r\n${e.value}%`;
  }
}
